/**
 * Split Quill document HTML at an index without mutating the editor.
 * Skips a leading paragraph-break "\n" on the second slice so getSemanticHTML
 * does not emit a leading empty <p><br></p>.
 */
export default (function splitQuillHtml(quill, splitAt) {
  const length = quill.getLength();
  let secondStart = splitAt;

  // Quill paragraph breaks are "\n"; starting a slice on one yields <p…><br></p>.
  while (secondStart < length - 1 && quill.getText(secondStart, 1) === "\n") {
    secondStart += 1;
  }
  const firstHtml = quill.getSemanticHTML(0, splitAt);
  let secondHtml = quill.getSemanticHTML(secondStart, Math.max(0, length - 1 - secondStart));
  secondHtml = secondHtml.replace(/^(<p\b[^>]*>\s*<br\s*\/?>\s*<\/p>)+/i, "");
  return {
    firstHtml,
    secondHtml
  };
});